import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaHolidaysCheckbox} from '@/features/agenda/components/agenda-holidays-checkbox/AgendaHolidaysCheckbox'
import {AgendaSidebarCalendar} from '@/features/agenda/components/agenda-sidebar-calendar/AgendaSidebarCalendar'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'
import {AgendaSidebarSearch} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearch'
import {AgendaSubjectSelection} from '@/features/agenda/components/agenda-subject-selection/AgendaSubjectSelection'

export const AgendaPatientSidebar = () => {
    return (
        <Flexbox direction="column" gap={3} fullWidth>
            <AgendaSidebarCalendar />
            <AgendaHolidaysCheckbox />
            <AgendaSidebarSearch searchTargets={['patients']} />
            <AgendaSubjectSelection target="patients" />
            <AgendaSidebarDottedDivider />
            {/* 
                Todo: Views will be implemented in the next release
                <AgendaSidebarViews userId={userId} target="patients" />
            */}
            {/* <AgendaSidebarDottedDivider /> */}
        </Flexbox>
    )
}
